import React from 'react';

import { cssMap } from '@atlaskit/css';
import { FlagsProvider } from '@atlaskit/flag';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import {
	AIDisclaimer,
	AIFeedbackComponent,
	AIFeedbackPropertiesProvider,
} from '@atlassian/ai-components';

// TODO: Replace with the actual entrypoint id, feature name, and content id when state is ready

const AUDIO_FEEDBACK_ENTRYPOINT_ID = 'palceholder-entrypoint-id';

const styles = cssMap({
	footerWrapper: {
		paddingInline: token('space.100'),
		paddingBlockStart: token('space.025'),
		paddingBlockEnd: token('space.075'),
	},
});

export const AudioFeedbackFooter = (): React.JSX.Element => {
	return (
		<FlagsProvider>
			<AIFeedbackPropertiesProvider
				entrypointId={AUDIO_FEEDBACK_ENTRYPOINT_ID}
				feedbackContext={{
					feature: 'briefing',
				}}
			>
				<Inline
					spread="space-between"
					grow="fill"
					alignBlock="start"
					alignInline="center"
					xcss={styles.footerWrapper}
				>
					<AIDisclaimer />
					<AIFeedbackComponent contentId="123" />
				</Inline>
			</AIFeedbackPropertiesProvider>
		</FlagsProvider>
	);
};
